/**
 * avatars/aliens/species-data.js
 * Dữ liệu 30 chủng tộc văn minh (CIVILIZED_SPECIES).
 * Thuần dữ liệu, không phụ thuộc DOM/Three.js.
 * Được hợp nhất từ 3 batch để đảm bảo cấu trúc module < 500 dòng.
 */

import { SPECIES_BATCH_1 } from './species/species-batch1.js';
import { SPECIES_BATCH_2 } from './species/species-batch2.js';
import { SPECIES_BATCH_3 } from './species/species-batch3.js';

export const CIVILIZED_SPECIES = {
  ...SPECIES_BATCH_1,
  ...SPECIES_BATCH_2,
  ...SPECIES_BATCH_3
};
